import { useQuery } from "@tanstack/react-query";

import { api } from "@/config/api";
import { queryKeys } from "@/hooks/queries";
import type { ApiResponse, LeaderboardEntry, StatsBreakdown, UserStats } from "@/types";

interface StatsApiResponse extends ApiResponse {
  stats: UserStats;
}

interface LeaderboardApiResponse extends ApiResponse {
  leaderboard: LeaderboardEntry[];
}

export function useStats() {
  return useQuery({
    queryKey: queryKeys.stats,
    queryFn: () => api.get<StatsApiResponse>("/api/stats"),
    select: (data) => data.stats,
  });
}

interface BreakdownApiResponse extends ApiResponse {
  breakdown: StatsBreakdown;
}

export function useStatsBreakdown() {
  return useQuery({
    queryKey: [...queryKeys.stats, "breakdown"],
    queryFn: () => api.get<BreakdownApiResponse>("/api/stats/breakdown"),
    select: (data) => data.breakdown,
  });
}

export function useLeaderboard(limit = 20) {
  return useQuery({
    queryKey: [...queryKeys.leaderboard, limit],
    queryFn: () =>
      api.get<LeaderboardApiResponse>(`/api/leaderboard?limit=${limit}`),
    select: (data) => data.leaderboard,
  });
}
